import { useTranslation } from "@outschool/localization";

type TranslatedPriceDisplayType = {
  priceMaxString: string;
  priceMinString: string;
  anyPriceString: string;
};

export default function usePriceFilterString() {
  const { t } = useTranslation("client\\hooks\\usePricePerMeetingFilter");

  return {
    getTranslatedPriceStrings: (
      priceMaxDisplay: string,
      priceMinDisplay: string,
    ): TranslatedPriceDisplayType => ({
      priceMaxString: t("{{priceMaxDisplay}} or less", { priceMaxDisplay }),
      priceMinString: t("Over {{priceMinDisplay}}", { priceMinDisplay }),
      anyPriceString: t("Any"),
    }),
    getTranslatedPricePerSessionStrings: (
      pricePerSessionMaxDisplay: string,
      pricePerSessionMinDisplay: string,
    ): TranslatedPriceDisplayType => ({
      priceMaxString: t("{{pricePerSessionMaxDisplay}}/session or less", {
        pricePerSessionMaxDisplay,
      }),
      priceMinString: t("Over {{pricePerSessionMinDisplay}}/session", {
        pricePerSessionMinDisplay,
      }),
      anyPriceString: t("Any"),
    }),
    getTranslatedPricePerWeekStrings: (
      pricePerWeekMaxDisplay: string,
      pricePerWeekMinDisplay: string,
    ): TranslatedPriceDisplayType => ({
      priceMaxString: t("{{pricePerWeekMaxDisplay}}/week or less", {
        pricePerWeekMaxDisplay,
      }),
      priceMinString: t("Over {{pricePerWeekMinDisplay}}/meeting", {
        pricePerWeekMinDisplay,
      }),
      anyPriceString: t("Any"),
    }),
    // TODO: This is a duplicate of getTranslatedPriceStrings. We should
    // remove this once we have contextual search filters working.
    getTranslatedPricePerMeetingStrings: (
      pricePerMeetingMaxDisplay: string,
      pricePerMeetingMinDisplay: string,
    ): {
      pricePerMeetingMaxString: string;
      pricePerMeetingMinString: string;
      anyPriceString: string;
    } => ({
      pricePerMeetingMaxString: t("{{pricePerMeetingMaxDisplay}} or less", {
        pricePerMeetingMaxDisplay,
      }),
      pricePerMeetingMinString: t("More than {{pricePerMeetingMinDisplay}}", {
        pricePerMeetingMinDisplay,
      }),
      anyPriceString: t("Any"),
    }),
  };
}
